import Page from "../Common/Page";
import React from "react";
import { Form, Input, Button, Row, Col, Divider, Alert, Space } from "antd";
import { UserOutlined, MailOutlined, BankOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { http } from "../Common/http";
import { Messages } from "../Common/ValidateMessages";

type FormData = {
  university: string;
  account: string;
  email: string;
};

export default class ReminderPage extends React.Component<any> {
  state = {
    loginError: "none",
    loginErrorMsg: "",
  };
  private _page: React.RefObject<Page>;
  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
  }

  submitForm = async (data: FormData) => {
    this.setState({ loginError: "none" });
    this.setState({ loginErrorMsg: "" });
    this._page.current?.setState({ isPageLoading: true });

    try {
      const result = await http<
        undefined,
        {
          UniversityCode: string;
          UserAccount: string;
          Email: string;
        }
      >({
        path: "/Reminder",
        method: "post",
        body: {
          UniversityCode: data.university,
          UserAccount: data.account,
          Email: data.email,
        },
        noResponsebody: true,
      });
      if (result.ok) {
        this.setState({ loginError: "none" });
        this._page.current?.setState({ isPageLoading: false });
        window.location.replace("/PasswordEnd");
      } else {
        if (result.statusCode === 404) {
          this.setState({ loginErrorMsg: Messages["ERR-002"] });
          this.setState({ loginError: "" });
        } else {
          this.setState({ loginErrorMsg: Messages["ERR-028"] });
          this.setState({ loginError: "" });
        }
        this._page.current?.setState({ isPageLoading: false });
      }
    } catch (error) {
      /* Exception */
      this.setState({ loginErrorMsg: Messages["ERR-028"] });
      this.setState({ loginError: "" });
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFormValueChange = () => {
    this.setState({ loginError: "none" });
    this.setState({ loginErrorMsg: "" });
  };

  render() {
    return (
      <Page ref={this._page} noCheckAuthority={true}>
        <Row justify="center">
          <Col span={6}>
            <h1 className="iiscore-title">iiscore-U</h1>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={6}>
            <Divider orientation="left">パスワード再設定</Divider>
          </Col>
        </Row>
        <Row justify="center" style={{ display: this.state.loginError }}>
          <Col span={6}>
            <Alert
              type="error"
              description={this.state.loginErrorMsg}
              message="エラー"
            />
          </Col>
        </Row>

        <Row justify="center">
          <Col span={6}>
            <Form
              name="reminder"
              layout="vertical"
              onFinish={this.submitForm}
              onValuesChange={this.onFormValueChange}
              autoComplete="off"
              className="login-form"
            >
              <Form.Item
                name="university"
                label="大学コード"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                  },
                ]}
              >
                <Input
                  prefix={<BankOutlined className="site-form-item-icon" />}
                  size="middle"
                  placeholder="大学コード"
                  maxLength={7}
                />
              </Form.Item>
              <Form.Item
                name="account"
                label="ユーザアカウント"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                  },
                ]}
              >
                <Input
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  size="middle"
                  placeholder="ユーザアカウント"
                  maxLength={30}
                />
              </Form.Item>
              <Form.Item
                name="email"
                label="メールアドレス"
                rules={[
                  {
                    required: true,
                  },
                  {
                    type: "email",
                  },
                  { max: 100 },
                ]}
              >
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<MailOutlined className="site-form-item-icon" />}
                  placeholder="メールアドレス"
                />
              </Form.Item>
              <br />
              <Form.Item>
                <Space split={<Divider type="vertical" />} size={"large"}>
                  <Button
                    size="middle"
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    確認する
                  </Button>
                  <Link to={"/Login"}>ログインはこちら</Link>
                </Space>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Page>
    );
  }
}
